import { useTranslation } from 'react-i18next';
import { CustomerInvoicingAddressModel } from '../../../../models/Customers';
import { ErrorState } from '../../../../models/Errors';
import { resources } from '../../../../resources/resources';
import { InvoicingAddress } from '../../../Common/Dialogs/InvoicingAddress/types';
import { ExistingInvoicingAddress } from './ExistingInvoicingAddress';
import { NewInvoicingAddress } from './NewInvoicingAddress';

interface InvoicingAddressFormProps {
  invoicingAddress: InvoicingAddress | null;
  setInvoicingAddress: (address: InvoicingAddress | null) => void;
  customerInvoicingAddress?: CustomerInvoicingAddressModel;
  setUpdateCustomerInvoicingAddress: (update: boolean) => void;
  errors: ErrorState;
  setErrors: (errors: ErrorState) => void;
}

export const InvoicingAddressForm = (props: InvoicingAddressFormProps) => {
  const {
    invoicingAddress,
    setInvoicingAddress,
    customerInvoicingAddress,
    setUpdateCustomerInvoicingAddress,
    errors,
    setErrors,
  } = props;
  const { t: translate } = useTranslation();

  return (
    <>
      <div className="invoicing-header">
        <h2>
          {translate(resources.invoicingAddress.cart.invoicingAddress.title)}
        </h2>
      </div>

      <div>
        {!customerInvoicingAddress ? (
          <NewInvoicingAddress
            invoicingAddress={invoicingAddress}
            setInvoicingAddress={setInvoicingAddress}
            setUpdateCustomerInvoicingAddress={
              setUpdateCustomerInvoicingAddress
            }
            errors={errors}
            setErrors={setErrors}
          />
        ) : (
          <ExistingInvoicingAddress
            invoicingAddress={invoicingAddress!}
            setInvoicingAddress={setInvoicingAddress}
            setUpdateCustomerInvoicingAddress={
              setUpdateCustomerInvoicingAddress
            }
          />
        )}
      </div>
    </>
  );
};
